var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    {
      staticClass: "cursor-pointer full-width",
      attrs: { inline: "" },
      nativeOn: {
        click: function($event) {
          return _vm.showNews()
        }
      }
    },
    [
      _c("q-card-media", [_c("img", { attrs: { src: _vm.getImage } })]),
      _c("q-card-title", [
        _vm._v("\n          " + _vm._s(_vm.news.title) + "\n      ")
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-actions",
        { staticClass: "justify-center" },
        [
          _c("q-btn", {
            attrs: {
              flat: "",
              label: _vm.fDate(_vm.news.created_date),
              icon: "fal fa-calendar"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }